// extracted by mini-css-extract-plugin
module.exports = {"marginSlider":"MarginSlider-module--marginSlider--2ys4I","thumb":"MarginSlider-module--thumb--3wqfe"};